module.exports = __webpack_public_path__ + "img/lerner-news-banner.eccc11a4.svg";